import styled from 'styled-components'
import { ChangeOwnerSearch } from './ChangeOwnerSearch'

export const ChangeOwnerSearchUI = styled(ChangeOwnerSearch)``
